import { firebaseAction } from 'vuexfire'
import { db } from '@/db'

const decks = db.collection('decks')

const state = {
  decks: null
}

const actions = {
  getDecks: firebaseAction(({ bindFirebaseRef }) => {
    bindFirebaseRef('decks',
      decks.orderBy('title')
    )
  })
}

const getters = {
  currentDecks: (state) => {
    return state.decks
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  actions,
  getters
}
